import React from 'react';
import MealPage from './MealPage';
import { colors } from '../theme';
import { MEAL_LABELS } from '../constants/mealLabels';

const LunchPage = () => (
  <MealPage mealtime="lunch" title={MEAL_LABELS.lunch} accentColor={colors.meal.lunch} />
);

export default LunchPage;
